__turbopack_context__.v({
  "checkbox": "checkbox-module__a-Y_Ua__checkbox",
  "ideeri-secondary": "checkbox-module__a-Y_Ua__ideeri-secondary",
  "label": "checkbox-module__a-Y_Ua__label",
  "secondary": "checkbox-module__a-Y_Ua__secondary",
});
